import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c253b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "business" }, [
  /*#__PURE__*/_createElementVNode("span", null, " AI&大数据中心 ")
], -1))
const _hoisted_2 = { style: {"font-weight":"900"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_Item = _resolveComponent("Item")!
  const _component_Sub_menu = _resolveComponent("Sub-menu")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Sider = _resolveComponent("Sider")!
  const _component_Content = _resolveComponent("Content")!
  const _component_Layout = _resolveComponent("Layout")!

  return (_openBlock(), _createBlock(_component_Layout, {
    class: "Sider",
    id: "Sider"
  }, {
    default: _withCtx(() => [
      (_ctx.showSider)
        ? (_openBlock(), _createBlock(_component_Sider, {
            key: 0,
            style: { background: '#fff' },
            class: "sider"
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_Menu, {
                id: "dddddd",
                style: _normalizeStyle({ width: '200px', 'min-height': _ctx.menuHeight }),
                openKeys: _ctx.openKeys,
                "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
                selectedKeys: [_ctx.$route.path],
                mode: "inline",
                class: "myMenu",
                openChange: _ctx.openChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.path
                    }, [
                      (!item.children)
                        ? (_openBlock(), _createBlock(_component_Item, {
                            key: item.path,
                            onClick: ($event: any) => (_ctx.handleClick(item)),
                            class: "itemBox"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_2, [
                                _createTextVNode(_toDisplayString(item.name), 1),
                                _createVNode(_component_LinkOutlined)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_Sub_menu, {
                            onTitleClick: ($event: any) => (_ctx.titleClick(item)),
                            key: item.path,
                            class: _normalizeClass(["SubmenuOne", !item.children ? 'show' : '']),
                            title: item.name,
                            style: {"font-weight":"600"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (data) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: data.path
                                }, [
                                  (!data.children)
                                    ? (_openBlock(), _createBlock(_component_Item, {
                                        key: data.path,
                                        onClick: ($event: any) => (_ctx.handleClick(data))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(data.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_Sub_menu, {
                                        onTitleClick: ($event: any) => (_ctx.titleClick(data)),
                                        key: data.path,
                                        class: _normalizeClass(!data.children ? 'show' : ''),
                                        title: data.name,
                                        style: _normalizeStyle({
                      display: _ctx.getShow(data) ? 'none' : 'block',
                    })
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.children, (data3) => {
                                            return (_openBlock(), _createElementBlock(_Fragment, {
                                              key: data3.path
                                            }, [
                                              (!data3.children)
                                                ? (_openBlock(), _createBlock(_component_Item, {
                                                    key: data3.path,
                                                    onClick: ($event: any) => (_ctx.handleClick(data3)),
                                                    class: _normalizeClass(
                            _ctx.getShow(data3) ? 'layout_sideBar_hiddenBox' : ''
                          )
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(data3.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "class"]))
                                                : (_openBlock(), _createBlock(_component_Sub_menu, {
                                                    onTitleClick: ($event: any) => (_ctx.titleClick(data3)),
                                                    key: data3.path,
                                                    class: _normalizeClass(!data3.children ? 'show' : ''),
                                                    title: data3.name
                                                  }, null, 8, ["onTitleClick", "class", "title"]))
                                            ], 64))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["onTitleClick", "class", "title", "style"]))
                                ], 64))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["onTitleClick", "class", "title"]))
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["style", "openKeys", "selectedKeys", "openChange"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Content, {
        breadcrumb: [_ctx.$route.matched]
      }, null, 8, ["breadcrumb"])
    ]),
    _: 1
  }))
}